module.exports = __webpack_public_path__ + "static/img/image7.7f27347f.png";